import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://zwrawojhfwjgojnobyzk.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp3cmF3b2poZndqZ29qbm9ieXprIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjI3NzMwMjgsImV4cCI6MjA3ODM0OTAyOH0.nreXObEZu03eq7zLpWVLxB8DV_eUUse5BuQ1baljpv8'

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Import the supabase client like this:
// For React:
// import { supabase } from "@/integrations/supabase/client";
// For React Native:
// import { supabase } from "@/src/integrations/supabase/client";
